import React, { useCallback } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  TextField,
  Button,
  CircularProgress,

} from "@mui/material";
import { toast } from "react-toastify";
import { useState } from "react";
import { subscribe_newsletter } from "../../api/Enquiry";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSettings } from "../../context/Settings";
import { assetUrl } from "../../utils/baseUrls";

// ── Static data — hoisted outside component to prevent recreation ──
const menuItems = [
  { text: "Logos", path: "/logos" },
  { text: "Events", path: "/events" },
  { text: "Stories", path: "/stories" },
  { text: "About Us", path: "/about" },
  { text: "Contact Us", path: "/contact-us" },
];

export default function Footer() {

  const { settings, loadingg, error } = useSettings();

  const [emailError, setEmailError] = useState("");
  const [referralEmail, setReferralEmail] = useState("");
  const navigate = useNavigate();

  const validateEmail = useCallback((email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }, []);

  const [loading, setLoading] = useState(false);

  const handleRedirect = useCallback((url) => {
    window.open(url, "_blank");
  }, []);

  const handleReferralSubmit = useCallback(async () => {
    if (!referralEmail) {
      toast.error("Email is required");
      return;
    }

    if (!validateEmail(referralEmail)) {
      toast.error("Enter a valid email address");
      return;
    }

    const payload = { email: referralEmail };

    try {
      setLoading(true);
      const res = await subscribe_newsletter(payload);
      toast.success(res?.message || "Newsletter Subscribed successfully");
      setReferralEmail("");
      setEmailError("");
    } catch (err) {
      toast.error(err?.response?.data?.error || "Failed to subscribe");
    } finally {
      setLoading(false);
    }
  }, [referralEmail, validateEmail]);

  return (
    <>
      <Box
        sx={{
          py: 8,
          color: "black",
          backgroundImage: "url('/assets/images/footer_bg.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          boxShadow: "inset 0 20px 30px -10px rgba(0,0,0,0.5)",
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={{ xs: 3, sm: 4, md: 6 }}
            justifyContent="space-between"
          >
            {/* Column 1 */}
            <Grid
              size={{ xs: 12, sm: 6, md: 3 }}
              sx={{
                maxWidth: { md: "280px" },
                display: "flex",
                flexDirection: "column",
                mt: -4,
              }}
            >
              {/* LOGO WRAPPER (FIXED HEIGHT) */}
              {/* LOGO */}
              <Box
                sx={{
                  height: 80,
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  mb: 3,
                }}
              >
                <Box
                  component="img"
                  src={settings?.data?.logo ? assetUrl(settings.data.logo) : "/assets/images/logo.png"}
                  alt="Logo"
                  sx={{
                    maxHeight: 130,
                    width: "auto",
                    objectFit: "contain",
                  }}
                />
              </Box>



              {/* <Typography
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  mb: 1,
                }}
              >
               {settings?.data?.business_name || ' Greenheap Farms '}
              </Typography> */}

              <Typography
                variant="body2"
                sx={{
                  paddingTop:2,
                  lineHeight: 1.6,
                  overflowWrap: "break-word",
                  wordBreak: "break-word",
                }}
              >
                {settings?.data?.footer_description || ''}
              </Typography>
            </Grid>



            {/* Column 2 */}
            <Grid size={{ xs: 6, sm: 3, md: 2 }}>
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                gutterBottom
                color="primary"
              >
                Links
              </Typography>

              {/* {["Logos", "Events", "Stories", "About Us"].map((text) => ( */}

               
                  <Typography
                  
                  sx={{
                    mt: 1,
                    cursor: "pointer",
                    width: "fit-content",
                    borderBottom: "2px solid transparent",
                  }}
                   onClick={()=>navigate("/contact-us")}
                >
                Contact Us
                </Typography>
                
              <Typography

                sx={{
                  mt: 1,
                  cursor: "pointer",
                  width: "fit-content",
                  borderBottom: "2px solid transparent",
                }}
                onClick={() => navigate("/pages/about_us")}
              >
                About Us
              </Typography>

              <Typography

                sx={{
                  mt: 1,
                  cursor: "pointer",
                  width: "fit-content",
                  borderBottom: "2px solid transparent",
                }}
                onClick={() => navigate("/material-store")}
              >
                Material Store
              </Typography>

              <Typography

                sx={{
                  mt: 1,
                  cursor: "pointer",
                  width: "fit-content",
                  borderBottom: "2px solid transparent",
                }}
                onClick={() => navigate("/professional-services")}
              >
                Services
              </Typography>
              {/* // ))} */}


            </Grid>

            {/* Column 3 */}
            <Grid size={{ xs: 6, sm: 3, md: 2 }}>
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                gutterBottom
                color="primary"
              >
                Legal
              </Typography>
              {/* 
              {["GDPR", "Privacy Policy", "Terms of Service", "Disclaimer"].map(
                (text) => (
                  <Typography
                    key={text}
                    sx={{
                      mt: 1,
                      cursor: "pointer",
                      width: "fit-content",
                      borderBottom: "2px solid transparent",

                    }}
                  >
                    {text}
                  </Typography>
                )
              )} */}
              <Typography

                sx={{
                  mt: 1,
                  cursor: "pointer",
                  width: "fit-content",
                  borderBottom: "2px solid transparent",
                }}
                onClick={() => navigate("/pages/terms_condition")}
              >
                Terms & Conditions
              </Typography>

              <Typography

                sx={{
                  mt: 1,
                  cursor: "pointer",
                  width: "fit-content",
                  borderBottom: "2px solid transparent",
                }}
                onClick={() => navigate("/pages/privacy_policy")}
              >
                Privacy Policy
              </Typography>

              <Typography

                sx={{
                  mt: 1,
                  cursor: "pointer",
                  width: "fit-content",
                  borderBottom: "2px solid transparent",
                }}
                onClick={() => navigate("/pages/disclaimer_footer")}
              >
                Disclaimer
              </Typography>
            </Grid>

            {/* Newsletter */}
            <Grid size={{ xs: 12, sm: 12, md: 5 }}>
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                gutterBottom
                color="primary"
              >
                News Letter
              </Typography>

              <Typography variant="body2" sx={{ mb: 2 }}>
                Subscribe to our news channel to get latest updates
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <TextField
                  placeholder="Your Email Address"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={referralEmail}
                  onChange={(e) => setReferralEmail(e.target.value)}
                  sx={{
                    bgcolor: "white",
                    borderRadius: 1,
                    "& .MuiInputBase-input": {
                      py: 1,
                      fontSize: "0.85rem",
                    },
                  }}
                />

                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    px: 3,
                    py: 0.8,
                    fontSize: "0.8rem",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={handleReferralSubmit}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    "Subscribe"
                  )}
                </Button>


              </Box>

              {/* Social */}
              <Box sx={{ mt: 3 }}>
                <Typography variant="subtitle2" fontWeight="bold">
                  Follow Us
                </Typography>

                <Box sx={{ display: "flex", mt: 1, gap: 2 }}>
                  <Box
                    component="img"
                    src="/assets/images/youtube.png"
                    alt="YouTube"
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleRedirect(settings?.data?.youtube || "https://www.youtube.com")}
                    height={30}
                    width={30}
                  />
                  <Box
                    component="img"
                    src="/assets/images/whatsapp.png"
                    alt="WhatsApp"
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleRedirect(`https://wa.me/${settings?.data?.whatsapp}` || "https://www.whatsapp.com/")}
                    height={30}
                    width={30}
                  />
                  <Box
                    component="img"
                    src="/assets/images/insta.png"
                    alt="Instagram"
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleRedirect(settings?.data?.instagram || "https://www.instagram.com")}
                    height={30}
                    width={30}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Bottom Bar */}
      <Box
        sx={{
          backgroundColor: "primary.light",
          textAlign: "center",
          px: 1,
          py: 1,
        }}
      >
        <Typography>© 2026 Geo Rental Farms</Typography>
      </Box>
    </>
  );
}
